import { createReducer } from "@reduxjs/toolkit";
import type { ProcessingState } from "@redux/state/shared-types";
import { removeFromStudentFavorite, resetRemoveFromStudentFavorite } from "./remove-from-student-favorite";

const initialState: ProcessingState = {
  processing: "idle",
};

export const removeFromStudentFavoriteReducer = createReducer<ProcessingState>(initialState, builder => {
  builder.addCase(removeFromStudentFavorite.fulfilled, state => {
    return {
      ...state,
      processing: "success",
    };
  });
  builder.addCase(removeFromStudentFavorite.pending, state => {
    return {
      ...state,
      processing: "pending",
    };
  });
  builder.addCase(removeFromStudentFavorite.rejected, state => {
    return {
      ...state,
      processing: "failed",
    };
  });
  builder.addCase(resetRemoveFromStudentFavorite, () => {
    return initialState;
  });
});
